// extracted by mini-css-extract-plugin
export default {"cls1":"_5yKIsEEyUY4WWZDJvpl","cls2":"B1cShlzCYyX4tyLYZUwp _5yKIsEEyUY4WWZDJvpl"};